export default __webpack_public_path__ + "static/WebThumbnail-60afa069fac9a1248aa7c62acb0cf013.jpg";